"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _prop2 = _interopRequireDefault(require("lodash/fp/prop"));

var _omit2 = _interopRequireDefault(require("lodash/fp/omit"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default(entity) {
  return function (originalData, _a) {
    var meta = _a.meta;
    return (0, _omit2.default)([(0, _prop2.default)(entity.idAttribute)(meta)])(originalData);
  };
};

exports.default = _default;